import { render, staticRenderFns } from "./biaodan.vue?vue&type=template&id=f5a0d592&"
import script from "./biaodan.vue?vue&type=script&lang=ts&"
export * from "./biaodan.vue?vue&type=script&lang=ts&"
import style0 from "./biaodan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports